
document.addEventListener('DOMContentLoaded', function () {
    // Inicializa o slider de thumbs
    const galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4, // 4 thumbs visíveis
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            // Configuração responsiva para os thumbs
            320: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            768: { slidesPerView: 4 }
        }
    });

    // Inicializa o slider principal vinculado aos thumbs
    const galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        effect: 'fade', // Efeito suave de transição
        fadeEffect: { crossFade: true },
        navigation: {
            nextEl: '.next-produtos', // Sua seta customizada
            prevEl: '.prev-produtos', // Sua seta customizada
        },
        thumbs: {
            swiper: galleryThumbs, // Vincula ao slider de thumbs
        },
    });
});